var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"course-progress-bar"},_vm._l((_setup.numberOfModules),function(index){return _c('span',{key:index,staticClass:"marker",class:{ fill: _setup.completedModules[index - 1] }})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }